import { render, staticRenderFns } from "./CreateHolidayDialog.vue?vue&type=template&id=1a3f45e3&scoped=true"
import script from "./CreateHolidayDialog.ts?vue&type=script&lang=ts&external"
export * from "./CreateHolidayDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3f45e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a3f45e3')) {
      api.createRecord('1a3f45e3', component.options)
    } else {
      api.reload('1a3f45e3', component.options)
    }
    module.hot.accept("./CreateHolidayDialog.vue?vue&type=template&id=1a3f45e3&scoped=true", function () {
      api.rerender('1a3f45e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Holidays/components/CreateHolidayDialog/CreateHolidayDialog.vue"
export default component.exports